<template>
    <v-row align="center" justify="center">
        <v-col cols="12" class="mb-0">
            <v-card class="elevation-1">

                <v-card-title class="pa-1">
                    <v-toolbar flat color="transparent" sm="12">
                        <v-btn small dark color="primary" @click="dialog = true">
                            <v-icon left>fas fa-plus-square</v-icon>Registrar pago proveedor
                        </v-btn>
                        <v-divider class="mx-2" inset vertical></v-divider>
                        <SingleCalendar refElement="activeInicio" :input-date.sync="datesRange.start" title="Fecha inicio" />
                        <SingleCalendar refElement="activeFin" :input-date.sync="datesRange.end" title="Fecha fin" />

                        <v-divider class="mx-2" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-spacer></v-spacer>
                    <v-col cols="12" md="6" sm="12"></v-col>
                    <v-col cols="12" md="6" sm="12" class="d-flex justify-end">
                        <v-text-field v-model="search" append-icon="fas fa-search"
                            label="Buscar registros de pago" single-inline hide-details
                            placeholder="Buscar por razonSocial, folio, numero de operación"
                            @keydown.enter="searchPago">
                        </v-text-field>

                        <v-btn icon class="mt-4 ml-2" @click="reload()" title="Actualizar">
                            <v-icon dense>fas fa-sync</v-icon>
                        </v-btn>
                        
                        <v-tooltip left color="success">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn icon class="mt-4 ml-2" color="success" v-bind="attrs" v-on="on" dark
                                    @click="handleExcelExport">
                                    <v-icon dark left>fas fa-file-excel</v-icon>
                                </v-btn>
                            </template>
                            <span>Reporte de pagos</span>
                        </v-tooltip>
                        <Columns :headers.sync="headers"></Columns>
                    </v-col>
                </v-card-title>

                <v-card-text>
                    <v-data-table :headers="filteredHeaders" :items="listaPago" class="elevation-2" :loading="loading"
                        loading-text="Cargando... espera un momento" :options.sync="options"
                        :server-items-length="totalElements" :items-per-page="itemsPerPage"
                        :page.sync="page" @page-count="totalPages = $event"
                        hide-default-footer>
                        <template v-slot:[`item.actions`] ="{ item }">
                            <v-menu bottom offset-x rounded="lg" transition="slide-y-transition" color="black">
                                 <template v-slot:activator="{ on, attrs }">
                                    <v-btn icon v-bind="attrs" v-on="on" color="teal darken-1" class="white--text" small>
                                        <v-icon>fas fa-ellipsis-v</v-icon>
                                    </v-btn>
                                </template>
                                <v-list>
                                    <v-list-item disabled>
                                        <v-list-item-avatar>
                                            <v-icon small color="primary">fas fa-user-tag</v-icon>
                                        </v-list-item-avatar>
                                        <v-list-item-content>
                                            <v-list-item-subtitle>{{ item.folio }}</v-list-item-subtitle>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item @click.prevent="showDetail(item)">
                                        <v-list-item-title>
                                            <v-icon small class="mr-2">fas fa-clipboard-list</v-icon> Detalle del pago
                                        </v-list-item-title>
                                    </v-list-item>
                                    <v-list-item @click.prevent="showEvidences(item.id)">
                                        <v-list-item-title>
                                            <v-icon small class="mr-2">fa-solid fa-folder-open</v-icon> Ficheros/Evidencias
                                        </v-list-item-title>
                                    </v-list-item>
                                    <v-list-item @click.prevent="removePago({ pago: item })" v-if="!item.eliminado && isAdmin">
                                        <v-list-item-title class="bg-red darken-4">
                                            <v-icon small class="mr-2">fas fa-trash-alt</v-icon> Cancelar pago proveedor
                                        </v-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </template>
                         <template v-slot:[`item.status`] ="{ item }">
                            <v-chip small filter label :color="item.eliminado ? 'red' : 'primary'" dark
                            class="ma-2" text-color="white">
                                <v-icon x-small left color="white">fas fa-tag</v-icon>
                                {{ item.eliminado ? 'Cancelado' : 'Activo' }}
                            </v-chip>
                        </template>
                    </v-data-table>
                </v-card-text>
                <v-card-actions>
                    <PaginationNumber :itemsPerPage.sync="itemsPerPage" :pageCount.sync="totalPages"
                    :totalElements.sync="totalElements" :page.sync="page" :initialize.sync="initialize" />
                </v-card-actions>
            </v-card>
        </v-col>

        <NuevoPago :dialog="dialog" :handleModal="handleModal" :providers.sync="providers" :initialize.sync="initTablePago" v-if="dialog"/>
        <DetailPayment :dialog="dialogDetail" :handleModal="handleModalDetail" :pago="pago" v-if="dialogDetail"/>
        <ExcelExporterPago :dialog="dialogExcelExport" :handleModal="handleModalExcelExport" :providers.sync="providers" v-if="dialogExcelExport"/>
        <ViewFilesTable :lstFiles="lstEvidences" :dialog="dialogEvidences"
        title-files="Ficheros y evidencias de pago"
        v-if="dialogEvidences" :handleDialogFiles="handleDialogFiles">
        </ViewFilesTable>
    </v-row>
</template>

<script>
    import ProveedorPagoDataService from '@/service/catalogo/proveedor/pago/proveedorPagoDataService';
    import ProveedorDataService from '@/service/catalogo/proveedor/proveedorDataService';

    import { pagedTableMixin } from '@/mixins/serverTableMixin';
    import SingleCalendar from '@/components/shared/SingleCalendar.vue';
    import NuevoPago from './NuevoPago.vue';
    import DetailPayment from './DetailPayment.vue';
    import ExcelExporterPago from './ExcelExporterPago.vue';
    import Columns from '@/components/shared/Columns.vue';
    import PaginationNumber from '@/components/shared/PaginationNumber.vue';
    import ProveedorEvidenceFileService from '@/service/entrada/ProveedorEvidenceFileService';
    import ViewFilesTable from '@/components/shared/ViewFilesTable.vue';
    import Camera from '@/assets/camera.png';
    import UsuarioDataService from '@/service/usuario/UsuarioDataService';
    import { showErrorAlert, showSuccessAlert, escapeHtml } from '@/helpers/swalHelper';
import { extractMessage } from '@/helpers/errorHelper';
import { can, CAP } from '@/service/permiso/capacidades';

    export default {
        name: "ListaPago",
        mixins: [pagedTableMixin],
        components: { SingleCalendar, NuevoPago, DetailPayment, ExcelExporterPago, Columns, ViewFilesTable, PaginationNumber },
        created() {
            this.getProviders();
            this.fetchTableData();
        },
        props: {
            proveedorId: { type: Number, default: 0 },
        },
        data() {
            return {
                providers: [],
                listaPago: [],
                datesRange: {
                    start: '', end : ''
                    // start: getFirstDayOfCurrentMonth().toFormat('yyyy-MM-dd'),
                    // end: getToday().toFormat('yyyy-MM-dd')
                },
                headers: [
                    { text: 'Acciones', value: 'actions', sortable: false, groupable: false, show: true },
                    { text: 'Folio de pago', value: 'folio', groupable: false, show: true },
                    { text: 'Proveedor', value: 'provider.razonSocial', groupable: false, show: true },
                    { text: 'Fecha de pago', value: 'paymentDateNatural', groupable: false, show: true },
                    { text: 'Monto pagado', value: 'payedAmountNatural', groupable: false, show: true },
                    { text: 'Forma de pago', value: 'paymentMethodNatural', groupable: false, show: true },
                    { text: 'Folio de operación', value: 'operationNumber', groupable: false, show: true },
                    { text: 'Estatus', value: 'status', sortable: false, groupable: false, show: true },
                    { text: 'Registrado por', value: 'registeredBy', groupable: false, show: true },
                    { text: 'Creado por', value: 'createdBy', groupable: false, show: false },
                ],
                dialog: false,
                dialogDetail: false,
                dialogExcelExport: false,

                dialogEvidences: false,
                lstEvidences: [],
            }
        },
        methods: {
            searchPago(){
                this.doSearch();
            },
            fetchTable(params){
                return ProveedorPagoDataService.table( params );
            },
            applyRows({ rows, total, totalPages }){
                this.listaPago = rows;
                this.totalElements = total;
                this.totalPages = totalPages;
            },
            // Callback que reciben los diálogos de alta y edición.
            initTablePago(){
                this.reload();
            },
            getProviders(){
                ProveedorDataService.allProveedor().then( resp => {
                    this.providers = resp.data;
                })
            },
            showDetail( pago ){
                this.pago = pago;
                this.dialogDetail = true;
            },
            handleModal(){ this.dialog = !this.dialog; },
            handleModalDetail(){ this.dialogDetail = !this.dialogDetail; },
            handleModalExcelExport(){ this.dialogExcelExport = !this.dialogExcelExport; },
            handleExcelExport(){ this.dialogExcelExport = !this.dialogExcelExport },
            // watch evidences
            getListEvidences(paymentProviderId){
                let params = { page: 0, size: 25 };
                this.lstEvidences = [];
                ProveedorEvidenceFileService.table( params, paymentProviderId ).then( response => {
                    let evidences = response.data.rows.map(evidence => {
                        return {
                            ...evidence,
                            typeFile: evidence.type.startsWith('image') ? 'image' : 'pdf',
                            url: evidence.name != null ? `${this.$store.state.auth.rutaFichero}proveedorPagoEvidences/${evidence.name}` : Camera
                        };
                    });
                    this.lstEvidences = evidences;
                }).catch(err => {
                    this.$swal.fire({ position: 'top-end', icon: 'error', text: 'Error al cargar las evidencias: ' + extractMessage(err), showConfirmButton: false, timer: 3500 });
                })
            },
            showEvidences(paymentProviderId){
                this.dialogEvidences = true
                this.getListEvidences(paymentProviderId)
            },
            handleDialogFiles() { this.dialogEvidences = !this.dialogEvidences },
            removePago({ pago }) {
                const { id, folio, operationNumber, provider, paymentMethodNatural, paymentDateNatural, payedAmountNatural } = pago;
                this.$swal.fire({
                    html: `<div class="text-left text-sm">Estas seguro que deseas cancelar el pago <strong>Folio: ${escapeHtml(folio)} ?<br>${escapeHtml(provider.razonSocial)}</strong> <br> Referencia: ${escapeHtml(operationNumber)} <br>
                        Forma de pago: ${escapeHtml(paymentMethodNatural)} <br> Fecha de pago: ${escapeHtml(paymentDateNatural)} <br><strong>Monto pagado: ${escapeHtml(payedAmountNatural)}</strong>
                    </div>`,
                    text: "Esta accion no se podra revertir!",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "Si, cancelar!",
                    cancelButtonText: "No"
                }).then((result) => {
                    if (result.isConfirmed) {
                        ProveedorPagoDataService.cancelPayment(pago.id).then(resp => {
                            showSuccessAlert({ title: 'Pago cancelado', text: `El pago ${pago.folio} ha sido cancelado con exito`});
                            this.fetchTableData();
                        }).catch(err => {
                            showErrorAlert({ title: 'Error al cancelar el pago', text: extractMessage(err)});
                        });
                    }
                });
            }
        },

        computed: {

        // Filtros dinámicos: el mixin los manda al backend y
        // resetea la página a 1 cuando cambian.
        tableFilters() {
            return {
                startDate: this.datesRange.start,
                endDate: this.datesRange.end,
                providerId: this.proveedorId
            };
        },
            isAdmin(){ return can(CAP.ADMIN, UsuarioDataService.getUserRoles()); },
            filteredHeaders() { return this.headers.filter( h => h.show ); }
        }
    }
</script>